var render = function render(){var _vm=this,_c=_vm._self._c;return _c('submenu-content',{attrs:{"title":"Software","idToUrl":_vm.idToUrl,"links":_vm.softwareLinks,"active":_vm.active,"eventHub":_vm.eventHub}})
}
var staticRenderFns = []

export { render, staticRenderFns }